/* global module:false */
"use strict";

var $ = window.$;
var common = require('./common');

var TPBS_footer = (function(){
    /**
     * Check scrollTop position and adjust back-to-top button position
     */
    var adjustBackToTopPosition = function(scrollTop, winHeight, docHeight, contentHeight, navHeight){
        var oriBackToTopPosition = navHeight + contentHeight;

        var $backToTopHolder = $('#back-to-top-holder');

        if(docHeight > winHeight){
            $backToTopHolder.addClass('fixed');
        }

        if(scrollTop > 0 && docHeight > winHeight && (scrollTop + winHeight < oriBackToTopPosition)){
            // show move to top button
            if(!$backToTopHolder.hasClass('move_up'))
                $backToTopHolder.addClass('move_up');
        }else if(scrollTop + winHeight > oriBackToTopPosition || scrollTop === 0){
            $backToTopHolder.removeClass('move_up');
        }
        if(scrollTop + winHeight > oriBackToTopPosition){
            $backToTopHolder.removeClass('fixed');
        }
    };

    /**
     * Scroll Event handler
     */
    var adjustBackToTopPositionHandler = function(){
        // get scroll top
        var scrollTop = common.getWindowScrollTop();
        // get window & document height
        var winHeight = common.getWindowHeight();
        var docHeight = common.getDocumentHeight();

        // check if we scroll down to see the back to top button original position
        var contentHeight = common.getContentHeight();

        var navHeight = common.getNavHeight();

        adjustBackToTopPosition(scrollTop, winHeight, docHeight, contentHeight, navHeight);
    };

    /**
     * Scroll to top
     */
    var scrollToTop = function(){
        $('html, body').stop().animate({
            'scrollTop': 0
        }, 800, 'swing');
    };

    /**
     * Back to top btn click handler
     */
    var scrollToTopHandler = function(e){
        scrollToTop();
    }

    /**
     * Init Footer
     */
    var footerInit = function(){
        // handle move to top button position
        $(window).on('scroll', adjustBackToTopPositionHandler);
        adjustBackToTopPositionHandler();

        $(document).on('click', '#back-to-top-btn', scrollToTopHandler);
    };

    return {
        init: footerInit,
        adjustBackToTopPosition: adjustBackToTopPosition,
        scrollToTop: scrollToTop
    };
})();

module.exports = TPBS_footer;